import { useState, useEffect, useCallback, useMemo } from "react";
import { listEvents, getGearConflicts, listGear, listCrew } from "@/lib/api";
import { toast } from "sonner";

export function useCalendarData(role) {
  const [events, setEvents] = useState([]);
  const [conflicts, setConflicts] = useState([]);
  const [gear, setGear] = useState([]);
  const [crew, setCrew] = useState([]);
  const [loading, setLoading] = useState(true);
  const isCrew = role === "crew";

  const fetchData = useCallback(async () => {
    try {
      // Crew may only fetch their own events + own crew profile; conflicts
      // and gear endpoints reject crew logins.
      const [evRes, crewRes] = await Promise.all([listEvents(), listCrew()]);
      setEvents(evRes.data);
      setCrew(crewRes.data);
      if (!isCrew) {
        const [confRes, gearRes] = await Promise.all([getGearConflicts(), listGear()]);
        setConflicts(confRes.data);
        setGear(gearRes.data);
      }
    } catch {
      toast.error("Failed to load calendar data");
    } finally {
      setLoading(false);
    }
  }, [isCrew]);

  useEffect(() => { fetchData(); }, [fetchData]);

  const gearMap = useMemo(() => {
    const map = {};
    gear.forEach(g => { map[g.gear_id] = g.name; });
    return map;
  }, [gear]);

  const crewMap = useMemo(() => {
    const map = {};
    crew.forEach(c => { map[c.crew_id] = c.name; });
    return map;
  }, [crew]);

  return { events, conflicts, gear, crew, gearMap, crewMap, loading };
}
